import { CollectionViewParamsConfig } from 'framework/ViewTypes';
import { FilterCondition } from 'framework/types';
import { useCollectionPager } from 'framework/ViewTypes/hooks';
import { ASC } from 'framework/list';
import type { RecruitmentPool, RecruitmentPoolsFilters } from '../types';
import useRecruitmentPoolService from '../useRecruitmentPoolService';

const VIEW_PARAMS_CONFIG: CollectionViewParamsConfig<RecruitmentPoolsFilters> = {
  defaultSortBy: 'name',
  defaultSortOrder: ASC,
  cache: true,
  filterRules: {
    status: { condition: FilterCondition.IN, values: ['ACTIVE', 'PAUSED', 'CLOSED'] },
  },
  sortableColumns: ['name', 'status'],
};

const useRecruitmentPoolsCollection = () => {
  const { search } = useRecruitmentPoolService();

  return useCollectionPager<RecruitmentPool, RecruitmentPoolsFilters>({
    pageSize: 30,
    viewParamsConfig: VIEW_PARAMS_CONFIG,
    fetchPage: ({ pageNumber, pageSize, filters, searchValue, sort, signal }) =>
      search(
        {
          pageNumber,
          pageSize,
          filter: {
            ...filters,
            ...(searchValue ? { name: { [FilterCondition.CT]: searchValue } } : {}),
          },
          sort,
        },
        { signal },
      ),
  });
};

export default useRecruitmentPoolsCollection;
